module.exports = __webpack_public_path__ + "img/seven4Green.5eaff66a.jpg";